import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LoaderModule } from '../../shared/modules/loader';
import { CommonHeaderComponent } from './components/common-header/common-header.component';
import { CommonRightSidebarComponent } from './components/common-right-sidebar/common-right-sidebar.component';
import { CommonSidebarComponent } from './components/common-sidebar/common-sidebar.component';
import { HeaderService } from './shared/service/header.service';
import { CommonContainerComponent } from './components/common-container/common-container.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoaderModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    ReactiveFormsModule
  ],
  declarations: [
    CommonContainerComponent,
    CommonHeaderComponent,
    CommonRightSidebarComponent,
    CommonSidebarComponent,
  ],
  providers: [HeaderService, BsModalService],
})
export class CommonLayoutModule {}
